import { render, staticRenderFns } from "./QuestionHistoryModal__Style#Drawer.vue?vue&type=template&id=08b744f1&scoped=true&"
import script from "./QuestionHistoryModal__Style#Drawer.vue?vue&type=script&lang=js&"
export * from "./QuestionHistoryModal__Style#Drawer.vue?vue&type=script&lang=js&"
import style0 from "./QuestionHistoryModal__Style#Drawer.vue?vue&type=style&index=0&id=08b744f1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b744f1",
  null
  
)

export default component.exports